import { IGetSpendingsResponse } from 'multirpc-sdk';
import { SpendingHistoryBarChartData } from '@ankr.com/telemetry';
import { t } from '@ankr.com/common';
import { format } from 'date-fns';

import { convertCreditsToUSD } from 'modules/billing/utils/convertCreditsToUSD';
import { DEAL_PROMO_EXTRA_REQUESTS_RATE } from 'modules/payments/components/PaymentForm/components/AmountInput/const';

export const mapSpendingsToChartData = (
  spendings?: IGetSpendingsResponse,
  avg?: number,
): SpendingHistoryBarChartData[] | undefined => {
  return spendings?.stats.map<SpendingHistoryBarChartData>(
    ({ stats, timestamp }) => {
      const totalBundleSpending = stats?.bundles?.total?.credit_amount
        ? Number(stats.bundles.total.credit_amount)
        : 0;

      const paygSpendings = stats?.payg ? Number(stats.payg) : 0;

      const paygSpendingInUsd = convertCreditsToUSD(
        paygSpendings,
        5,
      ).toNumber();

      const bundleSpendingInUsd = convertCreditsToUSD(
        totalBundleSpending,
        5,
        DEAL_PROMO_EXTRA_REQUESTS_RATE,
      ).toNumber();

      const date = new Date(Number(timestamp));

      return {
        avg,
        paygSpending: paygSpendingInUsd,
        dealSpending: bundleSpendingInUsd,
        formattedSpendingValue: t('statistics.usage-history.calls-number', {
          calls: paygSpendings,
        }),
        date: format(date, 'd LLL'),
        fullDate: format(date, 'd LLLL YYY'),
      };
    },
  );
};
